import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { Flag, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

function useFlag(name: string): UseQueryResult<AxiosResponse<Flag>> {
  const params: UrlParams = { name };
  return useQuery(['flag', name], () => client.get(`flags/${encodeUrlParams(params)}`), {
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: !!name,
  });
}

export default useFlag;
